import { render, staticRenderFns } from "./SupportsAdd.vue?vue&type=template&id=821021e6&scoped=true&"
import script from "./SupportsAdd.vue?vue&type=script&lang=js&"
export * from "./SupportsAdd.vue?vue&type=script&lang=js&"
import style0 from "./SupportsAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SupportsAdd.vue?vue&type=style&index=1&id=821021e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821021e6",
  null
  
)

export default component.exports